import {action, makeAutoObservable} from "mobx"
import PricesHistoryApi, {PriceAnswer} from "../../api/PricesHistoryApi"

export interface productStatus {
    price: string
    product_id: string
    old_price: string
    datetime: string
}

export interface productInfo {
    id: number
    name: string
    history: productStatus[]
}

class PricesHistoryController {
    productInfo: productInfo | undefined
    private _product_id: number  = -1
    prices: PriceAnswer[] = []
    private _total_count = -1
    private _page = 0
    private _p_page = 0
    private _pageCount = 100
    private _p_pageCount = 30
    private _countOfPages = 0
    private _p_countOfPages = 0
    private _loadStarted = false
    private _notExport = false

    get countOfPages(): number {
        return this._countOfPages
    }

    get pageCount(): number {
        return this._pageCount
    }

    get page(): number {
        return this._page
    }

    get pCountOfPages(): number {
        return this._p_countOfPages
    }

    get pPageCount(): number {
        return this._p_pageCount
    }

    get pPage(): number {
        return this._p_page
    }

    get notExport(): boolean {
        return this._notExport
    }

    constructor() {
        makeAutoObservable(this)
    }

    _productsLoaded: boolean = false

    get productsLoaded(): boolean {
        return this._productsLoaded
    }


    get pricesLoaded(): boolean {
        return this.prices && this.prices.length > 0
    }

    get productId(): number{
        return this._product_id
    }


    set productId(product_id:number) {
        this._product_id = product_id
    }

    private _search_query: string = ""

    get search_query(): string {
        return this._search_query
    }

    get totalCount(): number {
        return this._total_count
    }

    set search_query(value: string) {
        this._search_query = value
        this.loadPrices()
    }

    private _not_found: boolean = false

    get not_found(): boolean {
        return this._not_found
    }

    set not_found(value: boolean) {
        this._not_found = value
        this.loadPrices()
    }

    isHistoryPage(): boolean {
        return this._product_id === -1
    }

    isNewProduct(product_id: string) {
        if(+product_id !== this._product_id) {
            this._productsLoaded = false
        }

        return !this.productsLoaded
    }

    loadPrices(page = 0){
        if (+this._page === +page && this._loadStarted) {
            return false
        }
        this._loadStarted = true
        this._page = page
        PricesHistoryApi.history({page: this._page,
            filter:this._not_found,
            query:this._search_query,
            pageCount: this._pageCount,}).then(action("pricesHistoryLoaded",(result) => {
                this._loadStarted = false
                this.prices = result.data.data.prices
                this._countOfPages = result.data.data.totalPages
                if(this._total_count === -1) {
                    this._notExport = this.prices.length == 0
                    this._total_count = this._countOfPages * this._pageCount
                }
        }))
    }

    loadProductData(product_id?: string, page=0) {
        if (product_id) {
            this._product_id = +product_id
        }
        this._loadStarted = true
        this._p_page = page
        PricesHistoryApi.productData({id:this.productId,
            page:page,
            pageCount: this._p_pageCount
        }).then((result) => {
                this._loadStarted = false
                this.productInfo = result.data.data.info
                this._p_countOfPages = result.data.data.totalPages
                this._productsLoaded = true
            }
        )
    }
}

const pricesHistoryController = new PricesHistoryController()
export default pricesHistoryController